import { orderActionTypes } from '../actions/orderActions.js';
import { shoppingCartActionTypes } from '../actions/shoppingCartActions.js';
import { userActionTypes } from '../actions/userActions.js';
import { groupByKey } from '../../../utils/object.js';

/**
 * @type {OrderState.State}
 */
const initState = {
  orders: {},
  meals: {},
  drivers: {},
  reviewedOrders: [],
  loaded: false,
  isLoading: false,
  isLoadingMore: false,
  hasError: false,
};

const handleGetOrdersSuccess = (state, { orders }) => {
  const allOrders = {
    ...state.orders,
    ...orders,
  };
  return {
    ...state,
    ...{
      orders: allOrders,
      loaded: true,
      isLoading: false,
      hasError: false,
    },
  };
};

const handleGetMealsSuccess = (state, { meals }) => {
  const mealGroup = Array.isArray(meals)
    ? groupByKey(meals, (meal) => meal.id, true)
    : { [meals.id]: { ...meals } };
  const { meals: existingMeals } = state;
  const newMeals = { ...existingMeals, ...mealGroup };
  return { ...state, ...{ meals: newMeals, isLoading: false, hasError: false } };
};

const handlePlaceOrderSuccess = (state, { order }) => {
  const orders = { ...state.orders };
  orders[order.attributes.number] = order;
  return {
    ...state,
    ...{
      orders,
      loaded: true,
      isLoading: false,
      hasError: false,
    },
  };
};

const handleGetDriverLocationSuccess = (state, { driver }) => {
  const drivers = { ...state.drivers, ...driver };
  return {
    ...state,
    drivers,
  };
};

const handleCancelOrderSuccess = (state, { order }) => {
  const orders = { ...state.orders };
  orders[order.attributes.number] = order;
  return {
    ...state,
    ...orders,
  };
};

function handleReviewOrder(state, action) {
  const { reviewedOrders } = state;
  const { mealsReviews } = action;
  const { orderId } = mealsReviews[0];
  return { ...state, ...{ reviewedOrders: reviewedOrders.concat(orderId) } };
}

function handleSetPaymentInfo(state, action) {
  const orders = { ...state.orders };
  const order = { ...orders[action.orderNumber] };
  order.meta = {
    paymentInfo: action.paymentInfo,
  };
  orders[action.orderNumber] = order;
  return {
    ...state,
    orders,
  };
}

export default function orderReducer(state = initState, action) {
  switch (action.type) {
    case userActionTypes.LOGOUT:
      return initState;

    case orderActionTypes.getOrdersStart:
      return { ...state, ...{ loaded: false, isLoading: true, hasError: false } };

    case orderActionTypes.getOrdersSuccess:
      return handleGetOrdersSuccess(state, action);

    case orderActionTypes.getOrdersFailed:
      return { ...state, ...{ loaded: true, isLoading: false, hasError: true } };

    case orderActionTypes.getMealsSuccess:
      return handleGetMealsSuccess(state, action);

    case orderActionTypes.getMealsStart:
      return { ...state, ...{ isLoading: true, hasError: false } };

    case orderActionTypes.getMealsFailed:
      return { ...state, ...{ isLoading: false, hasError: true } };

    case orderActionTypes.getDriverLocationSuccess:
      return handleGetDriverLocationSuccess(state, action);

    case orderActionTypes.cancelOrderSuccess:
      return handleCancelOrderSuccess(state, action);

    case shoppingCartActionTypes.placeOrderSuccess:
      return handlePlaceOrderSuccess(state, action);

    case orderActionTypes.reviewOrderSuccess:
      return handleReviewOrder(state, action);

    case orderActionTypes.setPaymentInfo:
      return handleSetPaymentInfo(state, action);

    default:
      return state;
  }
}
